import React from 'react';
import Router from './router';

const App: React.FC = () => {
  return (
    <div className='app'>
      <Router />
    </div>
  );
};

export default App;
